// @flow

import paramsList from 'constants/paramsList';

export default (params: {}, queryObject: {}) => {
  const query = { ...queryObject };

  const updateQuery = (paramKey: string, value: string) => {
    query[paramKey] = query[paramKey].split('+').filter(i => i !== value).join('+');

    if (!query[paramKey].length) delete query[paramKey];
  };

  const updateArray = (paramKey: string, value: string | Array<any>) => {
    query[paramKey] = query[paramKey].filter(i => i !== value);

    if (!query[paramKey].length) delete query[paramKey];
  };

  const updateString = (paramKey, value) => {
    if (value) {
      query[paramKey] = value;
    } else delete query[paramKey];
  };

  Object.keys(params).forEach(paramKey => {
    const { type } = paramsList[paramKey];

    if (type === 'query') updateQuery(paramKey, params[paramKey]);
    if (type === 'array') updateArray(paramKey, params[paramKey]);
    if (type === 'string') updateString(paramKey, params[paramKey]);
  });

  return query;
};
